// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__PWSU5","slider":"style_slider__BWu1c","labelText":"style_labelText__qLZtU"};